// Center datepickers opened when in the quickview
document.querySelector('body').addEventListener('click', function(e) {
	if (!!e.target.hasAttribute('datepicker') && e.target.closest('.jsQuickview')) {
		var zebra = document.querySelectorAll('.Zebra_DatePicker').forEach(function(el) {
			el.style.setProperty('left', '50%', 'important');
			el.style.setProperty('top', '50%', 'important');
			el.style.setProperty('position', 'fixed', 'important');
			el.style.setProperty('transform', 'translate(-50%, -50%)', 'important');
		});
	}
}); 